module.exports = __webpack_public_path__ + "static/media/Picture3.8d2ac835.png";